<template>
  <sharing-metadata
    :metadata-props="instagramMetadata"
    @update="$emit('update', $event)"
    @invalid="$emit('invalid')"
  >
    <template v-slot:header>Instagram metadata</template>
    <template v-slot:content="contentData">
      <el-form-item label="Caption" prop="caption">
        <el-input
          v-model="contentData.metadata.caption"
          type="textarea"
          class="youtube-description__input"
          :rows="4"
        >
        </el-input>
      </el-form-item>
    </template>
  </sharing-metadata>
</template>

<script>
import SharingMetadata from "@/components/socials/share/metadata/SharingMetadata.vue";

// @group Socials
// Instagram sharing additional data (caption) input
export default {
  name: "SharingInstagramMetadata",
  components: {
    SharingMetadata
  },
  props: {
    /** Instagram video caption */
    caption: {
      type: String,
      default: ""
    }
  },
  /** maximum hashtags count in caption */
  maxHashtagsCount: 30,
  /** maximum mentions (@) count in caption */
  maxMentionsCount: 20,
  data() {
    return {
      /** local metadata var */
      metadata: {
        caption: this.caption
      },
      /** metadata restrictions */
      captionRules: [
        {
          max: 2200,
          message: "Max caption length is 2200",
          trigger: "change"
        },
        {
          /** restriction of hashtags count */
          validator: (rule, value, callback) => {
            const hashsCount = [...value.matchAll("#")].length;

            if (hashsCount > this.$options.maxHashtagsCount) {
              callback(Error("Max hashtags count is 30"));
            }

            callback();
          },
          trigger: "change"
        },
        {
          /** restriction of mentions (@) count */
          validator: (rule, value, callback) => {
            const mentionsCount = [...value.matchAll("@")].length;

            if (mentionsCount > this.$options.maxMentionsCount) {
              callback(Error("Max user mentions (@) count is 20"));
            }

            callback();
          },
          trigger: "change"
        }
      ]
    };
  },
  computed: {
    // @vuese
    // Instagram metadata properties
    instagramMetadata() {
      return [
        {
          id: "caption",
          value: this.caption,
          rules: this.captionRules
        }
      ];
    }
  }
};
</script>
